import api from "./api";
import * as types from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { camelizeKeys } from "humps";

export function loadApplicationFeatures() {
  return async (dispatch, getState) => {
    const applicationFeatures = getState().applicationFeatures;

    const shouldCallApi = !applicationFeatures || (!applicationFeatures.loaded && !applicationFeatures.loading);
    if (!shouldCallApi) return;

    try {
      dispatch({ type: types.LOAD_APPLICATION_FEATURES_STARTED });
      const response = await dispatch(sendHttpRequest(api.getApplicationFeatures()));

      const result = response.applicationFeatures.reduce(
        (prev, applicationFeature) => ({
          ...prev,
          [applicationFeature.featureCode.toLowerCase()]: applicationFeature.enabled
        }),
        {}
      );

      const camelizedJson = camelizeKeys(result);

      dispatch({ type: types.LOAD_APPLICATION_FEATURES_SUCCESS, payload: camelizedJson });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
